module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/ko_6-231f32739d18cc974ecdc229feeca0b2.jpg";